namespace $.$$ {
	
	$mol_style_define( $shm_hitalama_map_widget_float_notebook2_adds_line, {

		position: 'absolute',
		transform: 'translate(-50%, -50%)',
		justify: {
			content: 'center',
		},
		opacity: 0,
		pointerEvents: 'none',
		transition: 'none',
		overflow: 'visible',
		'[shm_hitalama_map_widget_float_notebook2_add_line_showed]': {
			true: {
				opacity: 1,
				pointerEvents: 'auto',
			},
		},

	} )
	
}
